"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _classnames = _interopRequireDefault(require("classnames"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _DropdownList = _interopRequireDefault(require("react-widgets/lib/DropdownList"));
var _cccisdConfirm = _interopRequireDefault(require("cccisd-confirm"));
var _arrowDown = _interopRequireDefault(require("cccisd-icons/arrow-down5"));
var _bin = _interopRequireDefault(require("cccisd-icons/bin"));
var _plus = _interopRequireDefault(require("cccisd-icons/plus2"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _ActionCondition = _interopRequireDefault(require("./ActionCondition.js"));
var _InfoLabel = _interopRequireDefault(require("../../../../components/InfoLabel"));
var _admin = require("../../../../selectors/admin.js");
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var BranchConfig = function BranchConfig(_ref) {
  var branchIndex = _ref.branchIndex,
    config = _ref.config,
    conditionKeyFrequencies = _ref.conditionKeyFrequencies,
    deleteBranch = _ref.deleteBranch,
    deploymentId = _ref.deploymentId,
    errors = _ref.errors,
    fields = _ref.fields,
    formulaMetrics = _ref.formulaMetrics,
    hideDefaultLabel = _ref.hideDefaultLabel,
    isDefault = _ref.isDefault,
    isReorderingBranches = _ref.isReorderingBranches,
    nextConditionKey = _ref.nextConditionKey,
    renderMoveBranches = _ref.renderMoveBranches,
    setNextConditionKey = _ref.setNextConditionKey,
    updateConfig = _ref.updateConfig;
  var _useState = (0, _react.useState)(true),
    _useState2 = _slicedToArray(_useState, 2),
    firstLoad = _useState2[0],
    setFirstLoad = _useState2[1];
  var _useState3 = (0, _react.useState)(config.branchName || ''),
    _useState4 = _slicedToArray(_useState3, 2),
    branchName = _useState4[0],
    setBranchName = _useState4[1];
  var _useState5 = (0, _react.useState)(config.conditions || [{}]),
    _useState6 = _slicedToArray(_useState5, 2),
    conditions = _useState6[0],
    setConditions = _useState6[1];
  var _useState7 = (0, _react.useState)(config.formulaCompareType || null),
    _useState8 = _slicedToArray(_useState7, 2),
    formulaCompareType = _useState8[0],
    setFormulaCompareType = _useState8[1];
  var _useState9 = (0, _react.useState)(config.formulaCompareValue || ''),
    _useState10 = _slicedToArray(_useState9, 2),
    formulaCompareValue = _useState10[0],
    setFormulaCompareValue = _useState10[1];
  var _useState11 = (0, _react.useState)(config.formulaId || null),
    _useState12 = _slicedToArray(_useState11, 2),
    formulaId = _useState12[0],
    setFormulaId = _useState12[1];
  var _useState13 = (0, _react.useState)(true),
    _useState14 = _slicedToArray(_useState13, 2),
    isBranchExpanded = _useState14[0],
    setIsBranchExpanded = _useState14[1];
  var _useState15 = (0, _react.useState)(false),
    _useState16 = _slicedToArray(_useState15, 2),
    isReorderingConditions = _useState16[0],
    setIsReorderingConditions = _useState16[1];
  var projectDeployments = (0, _reactRedux.useSelector)(function (state) {
    return (0, _admin.getCurrentProjectDeployments)(state.assignment.admin);
  });
  var currentRoleDcws = projectDeployments.filter(function (d) {
    return !d.archived && d.deploymentId !== deploymentId && d.roleHandle === currentRoleType();
  });

  /* /////////////////////////////////////////////////////////////////////////
  // LIFECYCLE METHODS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  (0, _react.useEffect)(function () {
    if (!firstLoad) {
      setBranchName(config.branchName || '');
      setConditions(config.conditions);
      setFormulaCompareType(config.formulaCompareType || null);
      setFormulaCompareValue(config.formulaCompareValue || '');
      setFormulaId(config.formulaId || null);
    } else {
      var startingConditions = _toConsumableArray(conditions);
      if (startingConditions.length === 1 && !startingConditions[0].key) {
        var newConditions = [_objectSpread(_objectSpread({}, startingConditions[0]), {}, {
          key: nextConditionKey
        })];
        setNextConditionKey(nextConditionKey + 1);
        changeField({
          target: {
            name: 'conditions',
            value: newConditions
          }
        }, setConditions);
      }
      setFirstLoad(false);
    }
  }, [config]);
  (0, _react.useEffect)(function () {
    if (!isBranchExpanded && errors) {
      setIsBranchExpanded(true);
    }
  }, [errors]);
  (0, _react.useEffect)(function () {
    if (!isBranchExpanded && hideDefaultLabel) {
      setIsBranchExpanded(true);
    }
  }, [hideDefaultLabel]);

  /* /////////////////////////////////////////////////////////////////////////
  // GENERAL FUNCTIONS //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function changeField(event, customSet) {
    var updatedConfig = _objectSpread({}, config);
    updatedConfig[event.target.name] = event.target.value;
    updateConfig(updatedConfig);
    customSet(event.target.value);
  }
  function currentRoleType() {
    var chosenDeployment = null;
    switch (fields.respondentConfig.value) {
      case 'managed':
        return fields.respondentSelection.value;
      case 'previous':
        chosenDeployment = projectDeployments.find(function (d) {
          return d.deploymentId === Number(fields.respondentSelection.value);
        });
        return chosenDeployment && chosenDeployment.roleHandle || undefined;
      default:
        return 'respondent';
    }
  }
  var renderCollapseArrow = /*#__PURE__*/_react["default"].createElement("div", {
    onClick: function onClick() {
      return setIsBranchExpanded(!isBranchExpanded);
    },
    className: (0, _classnames["default"])(_style["default"].collapseArrow, isBranchExpanded ? _style["default"].expanded : _style["default"].collapsed)
  }, /*#__PURE__*/_react["default"].createElement(_arrowDown["default"], null));

  /* /////////////////////////////////////////////////////////////////////////
  // CONDITION-RELATED //////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function addCondition() {
    var updatedConditions = [].concat(_toConsumableArray(conditions), [{
      action: 'message',
      completionMessage: 'You have completed the survey! Thank you for your response!',
      key: nextConditionKey
    }]);
    setNextConditionKey(nextConditionKey + 1);
    changeField({
      target: {
        name: 'conditions',
        value: updatedConditions
      }
    }, setConditions);
  }
  function deleteCondition(index) {
    return function () {
      (0, _cccisdConfirm["default"])({
        message: 'Delete Condition',
        description: 'Are you sure you want to delete this condition?'
      }).then(function () {
        // tinymce was re-using the same instance from the deleted
        // ActionCondition, so we must force it to re-initialize by
        // unmounting, then remounting a short time later.
        setIsReorderingConditions(true);
        changeField({
          target: {
            name: 'conditions',
            value: conditions.filter(function (_, i) {
              return i !== index;
            })
          }
        }, setConditions);
        setTimeout(function () {
          return setIsReorderingConditions(false);
        }, 25);
      });
    };
  }
  var renderAddConditionButton = /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-default",
    onClick: addCondition,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_plus["default"], null), /*#__PURE__*/_react["default"].createElement("span", {
    style: {
      marginLeft: '0.75rem'
    }
  }, "Add Condition"));
  function updateConditionConfig(index) {
    return function (updatedConditionConfig) {
      var updatedConditions = [];
      conditions.forEach(function (c, i) {
        updatedConditions.push(i === index ? updatedConditionConfig : c);
      });
      changeField({
        target: {
          name: 'conditions',
          value: updatedConditions
        }
      }, setConditions);
    };
  }

  /* /////////////////////////////////////////////////////////////////////////
  // BRANCH-RELATED /////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  function renderBranchName() {
    if (isDefault) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].indentedLabel, isBranchExpanded ? null : _style["default"].collapsedLabel)
      }, /*#__PURE__*/_react["default"].createElement("strong", null, "Default Branching Rule"));
    }
    if (!isBranchExpanded) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: (0, _classnames["default"])(_style["default"].indentedLabel, _style["default"].collapsedLabel)
      }, /*#__PURE__*/_react["default"].createElement("strong", null, "Branch Name:"), /*#__PURE__*/_react["default"].createElement("div", {
        className: _style["default"].collapsedField
      }, branchName));
    }
    var hasError = (0, _get2["default"])(errors, 'branchName');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(_style["default"].flexExpand, hasError ? 'has-error' : '')
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "control-label ".concat(_style["default"].indentedLabel)
    }, "Branch Name"), /*#__PURE__*/_react["default"].createElement("input", {
      className: "form-control",
      name: "branchName",
      onChange: function onChange(e) {
        return changeField(e, setBranchName);
      },
      type: "text",
      value: branchName
    }), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "help-block"
    }, hasError));
  }
  var renderDeleteBranchButton = isDefault ? null : /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
    title: "Delete Branching Rule"
  }, /*#__PURE__*/_react["default"].createElement("button", {
    className: "btn btn-sm btn-danger ".concat(_style["default"].deleteButton),
    onClick: deleteBranch,
    type: "button"
  }, /*#__PURE__*/_react["default"].createElement(_bin["default"], null)));
  function renderFormulaIdDropdown() {
    var hasError = (0, _get2["default"])(errors, 'formulaId');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(hasError ? 'has-error' : '', _style["default"].flexExpand)
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "control-label"
    }, /*#__PURE__*/_react["default"].createElement(_InfoLabel["default"], {
      label: "Formula",
      tooltip: "The formula whose value we will compare against. Note that all formulas associated with this Quest Project are listed."
    })), /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
      data: formulaMetrics,
      onChange: function onChange(e) {
        return changeField({
          target: {
            name: 'formulaId',
            value: e.variableId
          }
        }, setFormulaId);
      },
      placeholder: "--- Choose a Formula ---",
      itemComponent: function itemComponent(_ref2) {
        var item = _ref2.item;
        if (item) {
          return item.label || item.reportHeader || '';
        }
        return '';
      },
      value: formulaId,
      valueComponent: function valueComponent(_ref3) {
        var item = _ref3.item;
        if (item) {
          return item.label || item.reportHeader || '';
        }
        return '';
      },
      valueField: "variableId"
    }), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "help-block"
    }, hasError));
  }
  function renderFormulaCompareTypeDropdown() {
    var comparisonTypes = [{
      label: 'Equals',
      value: 'eq'
    }, {
      label: 'Greater Than',
      value: 'gt'
    }, {
      label: 'Greater Than or Equal To',
      value: 'gte'
    }, {
      label: 'Less Than',
      value: 'lt'
    }, {
      label: 'Less Than or Equal To',
      value: 'lte'
    }];
    var hasError = (0, _get2["default"])(errors, 'formulaCompareType');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(hasError ? 'has-error' : '', _style["default"].formulaPart, _style["default"].flexExpand)
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "control-label"
    }, "Comparison Type"), /*#__PURE__*/_react["default"].createElement(_DropdownList["default"], {
      data: comparisonTypes,
      onChange: function onChange(e) {
        return changeField({
          target: {
            name: 'formulaCompareType',
            value: e.value
          }
        }, setFormulaCompareType);
      },
      placeholder: "--- Choose a Comparison Type ---",
      textField: "label",
      value: formulaCompareType,
      valueComponent: function valueComponent(_ref4) {
        var item = _ref4.item;
        return item ? item.label : '';
      },
      valueField: "value"
    }), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "help-block"
    }, hasError));
  }
  function renderFormulaCompareValue() {
    var hasError = (0, _get2["default"])(errors, 'formulaCompareValue');
    return /*#__PURE__*/_react["default"].createElement("div", {
      className: (0, _classnames["default"])(hasError ? 'has-error' : '', _style["default"].formulaPart, _style["default"].flexExpand)
    }, /*#__PURE__*/_react["default"].createElement("label", {
      className: "control-label"
    }, "Comparison Value"), /*#__PURE__*/_react["default"].createElement("input", {
      className: "form-control",
      name: "formulaCompareValue",
      onChange: function onChange(e) {
        return changeField(e, setFormulaCompareValue);
      },
      type: "number",
      value: formulaCompareValue
    }), hasError && /*#__PURE__*/_react["default"].createElement("div", {
      className: "help-block"
    }, hasError));
  }

  /* /////////////////////////////////////////////////////////////////////////
  // RENDER /////////////////////////////////////////////////////////////////
  /////////////////////////////////////////////////////////////////////// */

  return /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].branchWrapper
  }, !hideDefaultLabel && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].branchNameWrapper
  }, renderCollapseArrow, renderBranchName(), !isDefault && isBranchExpanded && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].flexRight
  }, renderDeleteBranchButton, renderMoveBranches)), isBranchExpanded && /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, !isDefault && /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].formulaWrapper
  }, renderFormulaIdDropdown(), renderFormulaCompareTypeDropdown(), renderFormulaCompareValue()), conditions.map(function (conditionConfig, index) {
    return /*#__PURE__*/_react["default"].createElement(_ActionCondition["default"], {
      conditionConfig: conditionConfig,
      conditionKeyFrequencies: conditionKeyFrequencies,
      conditions: conditions,
      currentRoleDcws: currentRoleDcws,
      deleteCondition: deleteCondition(index),
      deploymentId: deploymentId,
      errors: (0, _get2["default"])(errors, "conditions.".concat(index)),
      fields: fields,
      index: index,
      isReorderingBranches: isReorderingBranches || isReorderingConditions,
      key: "".concat(branchIndex, "_").concat(index),
      updateConditionConfig: updateConditionConfig(index)
    });
  }), renderAddConditionButton));
};
BranchConfig.propTypes = {
  branchIndex: _propTypes["default"].oneOfType([_propTypes["default"].number, _propTypes["default"].string]),
  config: _propTypes["default"].object,
  conditionKeyFrequencies: _propTypes["default"].array,
  deleteBranch: _propTypes["default"].func,
  deploymentId: _propTypes["default"].number,
  errors: _propTypes["default"].object,
  fields: _propTypes["default"].object,
  formulaMetrics: _propTypes["default"].array,
  hideDefaultLabel: _propTypes["default"].bool,
  isDefault: _propTypes["default"].bool,
  isReorderingBranches: _propTypes["default"].bool,
  nextConditionKey: _propTypes["default"].number,
  renderMoveBranches: _propTypes["default"].node,
  setNextConditionKey: _propTypes["default"].func,
  updateConfig: _propTypes["default"].func
};
var _default = BranchConfig;
exports["default"] = _default;